export default {
  shapeName: "chevron/up",
  change: [
    {
      rotate: 90,
    },
  ],
};
